import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-profilesuccess-dialog',
  templateUrl: './profilesuccess-dialog.component.html',
  styleUrls: ['./profilesuccess-dialog.component.css'],
})
export class ProfilesuccessDialogComponent implements OnInit {
  constructor(private dialog: MatDialog) {}

  ngOnInit(): void {}
  close() {
    this.dialog.closeAll();
  }
}
